module.exports = __webpack_public_path__ + "img/update.e04e40f3.jpg";